'use client';

import {
    Box,
    Button,
    ButtonMarkup,
    ButtonVariant,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TextMarkup,
    TrilogyColor,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

export function ProAlert() {
    return (
        <Box shadowless flat backgroundColor={TrilogyColor.INFO_FADE}>
            <Text level={TextLevels.ONE} typo={[TypographyBold.TEXT_WEIGHT_SEMIBOLD, TypographyAlign.TEXT_CENTERED]}>
                Vous souhaitez changer de forfait&nbsp;?
            </Text>
            <View flexable className='gap-medium'>
                <Icon name={IconName.USER_HEADSET} size={IconSize.LARGE} />
                <div>
                    <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                        Appelez gratuitement le 1064
                    </Text>
                    <Text level={TextLevels.TWO}>
                        Nos conseillers vous accompagnent pour trouver le forfait qui vous correspond.
                    </Text>
                </div>
            </View>
            <Button
                markup={ButtonMarkup.A}
                variant={ButtonVariant.PRIMARY}
                href='tel:1064'
                className='is-hidden-tablet'
                fullwidth
            >
                Appeler le 1064
            </Button>
            <Text level={TextLevels.THREE} marginless>
                <Text markup={TextMarkup.SPAN}>Service client ouvert du</Text>
                <Text markup={TextMarkup.SPAN} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    {' '}
                    lundi au samedi de 8h à 20h.
                </Text>
            </Text>
        </Box>
    );
}
